import { FlowDefinition } from "../../core/flows/FlowDefinition";
import { StepDefinition } from "../../core/flows/StepDefinition";
import { NetworkMapStationInitStepDeclaration } from "./Steps/NetworkMapStationInitStep";

export const NetworkMapStationStartupFlow = new FlowDefinition("NetworkMapStationFlow");

NetworkMapStationStartupFlow.addStep(NetworkMapStationInitStepDeclaration);

NetworkMapStationStartupFlow.setStartStep("NetworkMapStationInit_Step");

export const NetworkMapStationStartupStepDefinition = new StepDefinition({
    stepName: "NetworkMapStationFlow",
    stepFlow: NetworkMapStationStartupFlow,
    contextIsolation: false
})